import React from 'react'
import { Image } from '../BlockLibrary/Common/Image'
import { addSlashToStr } from '../utilities';
import { RichText } from '../richTextOptions';

const ContentfulBlockIconWithText = block => {
     var className = ''
     if (block.isMobile === true) {
          className = 'icon-with-text-mobile';
     } else if (block.isMobile === false) {
          className = 'icon-with-text-desktop';
     } else {
          className = ''
     }

     return (
          <>
               {(block.h3Text && block.normalText) ? (
                    block.icon && (
                         <>
                              {
                                   block.link ? (
                                        <a className="icon-text-link" href={addSlashToStr(block.link)} target={block.targetLink === 'New Tab' ? '_blank' : '_self'}>
                                             <div className={`icon-container ${className}`}><Image image={block.icon} /></div>
                                             <div className="text-container">
                                                  <h3>{block.h3Text}</h3>
                                                  {block.normalText && <p dangerouslySetInnerHTML={{ __html: block.normalText }}></p>}
                                                  {block.htmlText && <div className="last-content-box-icon" dangerouslySetInnerHTML={{ __html: block.htmlText.childMarkdownRemark?.html ? block.htmlText.childMarkdownRemark.html : block.htmlText }}></div>}
                                                  {block.richText && <RichText data={block.richText}></RichText>}
                                             </div>
                                        </a>
                                   ) : (
                                             <>
                                                  <div className={`icon-container ${className}`}><Image image={block.icon} /></div>
                                                  <div className="text-container">
                                                       <h3>{block.h3Text}</h3>
                                                       {block.normalText && <p dangerouslySetInnerHTML={{ __html: block.normalText }}></p>}
                                                       {block.htmlText && <div className="last-content-box-icon" dangerouslySetInnerHTML={{ __html: block.htmlText.childMarkdownRemark?.html ? block.htmlText.childMarkdownRemark.html : block.htmlText }}></div>}
                                                       {block.richText && <RichText data={block.richText}></RichText>}
                                                  </div>
                                             </>
                                        )
                              }
                         </>
                    )
               ) : (
                         <>
                              {
                                   block.link ? (
                                        <a className="icon-text-link" href={addSlashToStr(block.link)} target={block.targetLink === 'New Tab' ? '_blank' : '_self'}>
                                             <div className={`icon-with-text ${className}`}>
                                                  {block.icon && <Image image={block.icon} />}
                                                  {block.h3Text && <h3>{block.h3Text}</h3>}
                                                  {block.normalText && <p dangerouslySetInnerHTML={{ __html: block.normalText }}></p>}
                                                  {block.htmlText && <div className="last-content-box-icon" dangerouslySetInnerHTML={{ __html: block.htmlText.childMarkdownRemark?.html ? block.htmlText.childMarkdownRemark.html : block.htmlText }}></div>}
                                                  {block.richText && <RichText data={block.richText}></RichText>}
                                                  {block.iconSecondary && <Image image={block.iconSecondary} />}
                                             </div>
                                        </a>
                                   ) : (
                                             <div className={`icon-with-text ${className}`}>
                                                  {block.icon && <Image image={block.icon} />}
                                                  {block.h3Text && <h3>{block.h3Text}</h3>}
                                                  {block.normalText && <p dangerouslySetInnerHTML={{ __html: block.normalText }}></p>}
                                                  {block.htmlText && <div className="last-content-box-icon" dangerouslySetInnerHTML={{ __html: block.htmlText.childMarkdownRemark?.html ? block.htmlText.childMarkdownRemark.html : block.htmlText }}></div>}
                                                  {block.richText && <RichText data={block.richText}></RichText>}
                                                  {block.iconSecondary && <Image image={block.iconSecondary} />}
                                             </div>
                                        )
                              }
                         </>
                    )}
          </>
     )
}

export { ContentfulBlockIconWithText }
